import { Link } from 'react-router-dom';
import { categories, kaspreadsheetUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-grid-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900">
                BaseTao Spreadsheet
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your trusted resource for BaseTao Spreadsheet tutorials, reviews, guides, and expert insights.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/basetao-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Complete Guide
                </Link>
              </li>
              <li>
                <a href={kaspreadsheetUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Main Store
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              Shop Categories
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              More Categories
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} BaseTao Spreadsheet Courses. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href={kaspreadsheetUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              kaspreadsheet.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}